if (!customElements.get("press-carousel")) {
  customElements.define(
    "press-carousel",
    class PressCarousel extends SliderComponent {
      constructor() {
        super();
        this.enableSliderLooping = true;

        this.sliderFirstItemNode = this.slider.querySelector(".press-carousel__slide");
        this.initPages();
        const resizeObserver = new ResizeObserver((entries) => this.initPages());
        resizeObserver.observe(this.slider);
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

        this.setSlideVisibility();

        if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
      }

      setAutoPlay() {
        this.autoplaySpeed = this.slider.dataset.speed * 1000;
        this.play();
      }

      play() {
        console.log("play");
        this.slider.setAttribute("aria-live", "off");
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
      }

      setSlideVisibility() {
        this.sliderItemsToShow.forEach((item, index) => {
          const button = item.querySelector("a");
          if (index === this.currentPage - 1) {
            item.classList.add("active"); // Ajoute la classe active
            if (button) button.removeAttribute("tabindex");
            item.setAttribute("aria-hidden", "false");
            item.removeAttribute("tabindex");
          } else {
            item.classList.remove("active"); // Retire la classe active
            if (button) button.setAttribute("tabindex", "-1");
            item.setAttribute("aria-hidden", "true");
            item.setAttribute("tabindex", "-1");
          }
        });
        this.quotesToShow = this.querySelectorAll(".press-carousel__slide--quote");
        this.quotesToShow.forEach((quote, index) => {
          if (index === this.currentPage - 1) {
            quote.classList.add("active"); // Ajoute la classe active
          } else {
            quote.classList.remove("active"); // Retire la classe active
          }
        });
      }

      autoRotateSlides() {
        // Vérifie si on est sur la dernière slide
        const isLastSlide = this.currentPage === this.sliderItems.length;

        // Calcul de la position de défilement
        const slideScrollPosition = isLastSlide
          ? 0 // Retourne au début si on est à la dernière slide
          : this.slider.scrollLeft + this.slider.querySelector(".press-carousel__slide").clientWidth;

        // Met à jour `currentPage` pour la prochaine slide
        this.currentPage = isLastSlide ? 1 : this.currentPage + 1;

        // Défilement fluide vers la position calculée
        this.slider.scrollTo({
          left: slideScrollPosition,
          behavior: "smooth", // Défilement fluide
        });

        // Met à jour la visibilité des slides
        this.setSlideVisibility();
      }
    }
  );
}
